import { Link } from "react-router-dom";
import { Heart, MapPin, Car } from "lucide-react";
import { imgUrl, money, CONDITION_LABELS, vehicleLine } from "@/lib/api";
import { StatusPill } from "@/components/States";

export const ListingCard = ({ item, onToggleSave }) => (
  <div data-testid={`listing-card-${item.id}`} className="group relative bg-white border border-slate-200 rounded-2xl overflow-hidden hover:border-blue-500/40 hover:shadow-lg transition-[box-shadow,border-color] duration-200">
    <Link to={`/listing/${item.id}`} className="block">
      <div className="aspect-square bg-slate-100 overflow-hidden">
        {item.photos?.[0] ? (
          <img src={imgUrl(item.photos[0])} alt={item.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-slate-400 text-sm">No photo</div>
        )}
      </div>
      <div className="p-3">
        <div className="flex items-center gap-2">
          <span className="font-extrabold text-slate-900 text-lg">{money(item.price)}</span>
          {item.price_type === "firm" && <span className="text-[10px] font-semibold uppercase text-slate-500">Firm</span>}
        </div>
        <p className="text-sm text-slate-800 truncate">{item.title}</p>
        {item.vehicle && <p data-testid="card-vehicle-info" className="text-xs text-slate-600 truncate">{vehicleLine(item.vehicle)}</p>}
        {item.vehicle?.test_drive && <span data-testid="card-testdrive-tag" className="mt-1 inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-700 bg-emerald-50 rounded-full px-2 py-0.5"><Car className="h-3 w-3" /> Test drive welcome</span>}
        <p className="text-xs text-slate-500 mt-1 flex items-center gap-1">
          <MapPin className="h-3 w-3" /> {item.city}
          {item.distance_mi != null && <> · {item.distance_mi} mi</>}
          <span className="ml-auto">{CONDITION_LABELS[item.condition]}</span>
        </p>
      </div>
    </Link>
    <div className="absolute top-2 left-2 flex gap-1">
      {item.status !== "active" && <StatusPill status={item.status} />}
      {item.is_demo && <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-white/90 text-slate-700 border border-slate-200">Demo</span>}
    </div>
    {onToggleSave && (
      <button
        data-testid={`save-toggle-${item.id}`}
        aria-label={item.saved ? "Unsave" : "Save"}
        onClick={() => onToggleSave(item)}
        className="absolute top-2 right-2 h-9 w-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow-sm hover:scale-105 transition-transform"
      >
        <Heart className={`h-4 w-4 ${item.saved ? "fill-blue-600 text-blue-600" : "text-slate-700"}`} />
      </button>
    )}
  </div>
);
